export default {
      id: "icon-bookmark-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-bookmark",
      toString: function () {
        return this.url;
      }
    }